import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';

import { BossItem } from '../models';

export enum BossActionTypes {
  GetReports = '[Boss] Load Items',
  GetReportsSuccess = '[Boss] Load Items Success',

  GetReport = '[Boss] Get Item',
  GetReportSuccess = '[Boss] Get Item Success',

  Refresh = '[Boss] Refresh',
  RefreshSuccess = '[Boss] Refresh Success',

  Download = '[Boss] Download',
  DownloadSuccess = '[Boss] Download Success',

  Failure = '[Boss] Failure',
}

export namespace BossActions {
  export namespace GetItems {
    export const request = createAction(BossActionTypes.GetReports);
    export const success = createAction(
      BossActionTypes.GetReportsSuccess,
      props<{ items: BossItem[] }>(),
    );
  }

  export namespace Refresh {
    export const request = createAction(
      BossActionTypes.Refresh,
      props<{ item: BossItem }>(),
    );
    export const success = createAction(
      BossActionTypes.RefreshSuccess,
      props<{ item: Update<BossItem> }>(),
    );
  }

  export namespace Download {
    export const request = createAction(
      BossActionTypes.Download,
      props<{ item: BossItem }>(),
    );
    export const success = createAction(
      BossActionTypes.DownloadSuccess,
      props<{ item: BossItem }>(),
    );
  }

  export const failure = createAction(
    BossActionTypes.Failure,
    props<{ item?: BossItem; errorMessage: string }>(),
  );
}
